exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideSelectorContainer .slideSelectorWrapper[data-v-be4a843c]{color:#000}", ""]);

// exports
